import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { configureStore, combineReducers } from "@reduxjs/toolkit";

import bonusReducer from "./slice/bonusSlice";
import adminNotificationSlice from "./slice/adminNotificationSlice";
import settingsReducer from "./slice/settingsSlice";
import loanFilterSlice from "./slice/loanFilterSlice";
import floorCasesSlice from "./slice/floorCasesSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const rootReducer = combineReducers({
  bonus: bonusReducer,
  adminNotificationFilter: adminNotificationSlice,
  settings: settingsReducer,
  loanProductFilter: loanFilterSlice,
  floorCaseFilter: floorCasesSlice
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// const store = configureStore({
//   reducer: rootReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: false,
//     }),
// });

// export default store;

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
